import { render, staticRenderFns } from "./LookSchoolProfile.vue?vue&type=template&id=4dc888c9"
import script from "../../services/student/look-school-profile.js?vue&type=script&lang=js&external"
export * from "../../services/student/look-school-profile.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports